// Reglas de cuentas y dispositivos usadas por las Edge Functions y los scripts de alta.

export const MAX_PIN_ATTEMPTS = 5;
export const PIN_LOCK_MINUTES = 15;

export interface PinAttemptState {
  failed_attempts: number;
  locked_until: string | null;
}

export function isLocked(state: PinAttemptState, now: Date): boolean {
  return state.locked_until !== null && new Date(state.locked_until).getTime() > now.getTime();
}

/** Estado después de un PIN incorrecto: al llegar al máximo se bloquea y se reinicia el contador. */
export function registerPinFailure(state: PinAttemptState, now: Date): PinAttemptState {
  const failed = state.failed_attempts + 1;
  if (failed >= MAX_PIN_ATTEMPTS) {
    return {
      failed_attempts: 0,
      locked_until: new Date(now.getTime() + PIN_LOCK_MINUTES * 60_000).toISOString(),
    };
  }
  return { failed_attempts: failed, locked_until: state.locked_until };
}

export const PIN_OK_STATE: PinAttemptState = { failed_attempts: 0, locked_until: null };

/** Menor código libre para un dispositivo nuevo (1..9999). Se usa como prefijo de tickets. */
export function nextDeviceCode(usedCodes: Iterable<number>): number {
  const used = new Set(usedCodes);
  for (let code = 1; code <= 9999; code++) {
    if (!used.has(code)) return code;
  }
  throw new Error('El negocio alcanzó el máximo de dispositivos.');
}

export function formatDeviceCode(code: number): string {
  return String(code).padStart(4, '0');
}

/** "Almacén Don José" → "almacen-don-jose" */
export function slugify(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 50)
    .replace(/-+$/g, '');
}

/**
 * Email interno de un empleado. Los empleados no usan email: Supabase Auth lo necesita
 * como identificador, así que se genera uno que nunca recibe correo.
 */
export function employeeAuthEmail(membershipId: string, domain: string): string {
  return `emp-${membershipId}@${domain}`;
}
